import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
  getServiceArchive,
  type ServiceArchiveEntryDto,
  type ServiceArchivePageDto,
  type ServiceArchiveQuery,
} from '@/api/service-archive.api'
import { resetStore } from '@/store/actions/reset'
import { Status } from '@/types/general-types'
import { getErrorMessage } from '@/utils/utils'

interface ServiceArchiveState {
  data: ServiceArchiveEntryDto[]
  total: number
  status: Status
  requestId: string | null
}

const initialState: ServiceArchiveState = {
  data: [],
  total: 0,
  status: 'idle',
  requestId: null,
}

export const fetchServiceArchive = createAsyncThunk<ServiceArchivePageDto, ServiceArchiveQuery>(
  'serviceArchive/fetch',
  async (query, { rejectWithValue }) => {
    try {
      return await getServiceArchive(query)
    } catch (error) {
      return rejectWithValue(getErrorMessage(error))
    }
  },
)

const serviceArchiveSlice = createSlice({
  name: 'serviceArchive',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceArchive.pending, (state, action) => {
        state.requestId = action.meta.requestId
        state.status = 'loading'
      })
      // Filtry i strona zmieniają się szybciej, niż wraca odpowiedź — liczy się tylko ostatnie żądanie.
      .addCase(fetchServiceArchive.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return
        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
      })
      .addCase(fetchServiceArchive.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return
        state.status = 'failed'
      })
      .addCase(resetStore, () => initialState)
  },
})

export default serviceArchiveSlice.reducer
